export const menu = {    
    mainItems: ['Explore', 'Library', 'History', 'Sanskrit', 'Settings'],
    mainIcons: ['mdi-compass', 'mdi-plus-box-multiple', 'mdi-history', 'mdi-alpha-s-box-outline', 'mdi-cog'],
    mainActive: [true, false, false, false, false]
    // mainItems: ['Explore', 'Library', 'History'],
    // mainIcons: ['mdi-compass', 'mdi-plus-box-multiple', 'mdi-history'],
    // mainActive: [true, false, false]
    }
